import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitigrishneshwar() {



const cardData = {
  keyword: " Mumbai to Grishneshwar Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Grishneshwar cab services for devotees and travelers planning a spiritual journey to one of the most sacred Jyotirlinga temples in India. Grishneshwar Temple, located near Ellora in Maharashtra, is dedicated to Lord Shiva and is recognized as the twelfth Jyotirlinga, attracting pilgrims from across the country. Whether you are planning a religious trip, a family pilgrimage, or a combined tour including Ellora Caves and Aurangabad sightseeing, our cab service ensures a safe and smooth travel experience with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Grishneshwar is approximately 330–350 km depending on the route. We provide flexible booking options including one-way cab service, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, skilled chauffeurs familiar with long-distance highway travel, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Grishneshwar cab booking.",

topPlaces: [
  {
    title: "Grishneshwar Jyotirlinga Temple",
    description:
      "Grishneshwar Temple is the main pilgrimage attraction and one of the twelve Jyotirlingas dedicated to Lord Shiva in India. The temple features beautiful red stone architecture with intricate carvings and sculptures reflecting traditional Hindu temple design. Devotees visit throughout the year to perform rituals, offer prayers, and experience the powerful spiritual atmosphere of the temple. The temple complex also includes sacred water tanks and prayer halls where pilgrims gather for religious ceremonies. Traveling by cab from Mumbai allows devotees to comfortably reach the temple and spend enough time for peaceful darshan and spiritual activities."
  },
  {
    title: "Ellora Caves",
    description:
      "Ellora Caves are one of the most famous UNESCO World Heritage Sites in India and are located very close to Grishneshwar Temple. The cave complex consists of 34 rock-cut caves representing Buddhist, Hindu, and Jain religious traditions. The highlight of the site is the magnificent Kailasa Temple, which is carved from a single rock and is considered one of the greatest architectural achievements in ancient India. Visitors exploring the caves can admire intricate sculptures, ancient murals, and impressive stone structures. A cab journey from Mumbai allows travelers to easily combine Grishneshwar temple darshan with a visit to these remarkable historic caves."
  },
  {
    title: "Kailasa Temple",
    description:
      "Kailasa Temple, located within the Ellora Caves complex, is one of the largest monolithic rock-cut temples in the world. The temple was carved out of a single massive rock and is dedicated to Lord Shiva. Its grand architecture includes massive pillars, beautifully carved walls, and intricate sculptures depicting scenes from Hindu mythology. Visitors are amazed by the scale and artistic detail of the temple, which reflects the engineering brilliance of ancient Indian craftsmen. Traveling by cab from Mumbai provides a convenient way to explore this extraordinary architectural masterpiece."
  },
  {
    title: "Daulatabad Fort",
    description:
      "Daulatabad Fort is a historic hill fort located near Aurangabad and not far from Grishneshwar Temple. The fort is famous for its strong defensive structures, steep pathways, and impressive architecture that made it nearly impossible to conquer in ancient times. Visitors can explore the fort’s massive gates, watchtowers, underground passages, and scenic viewpoints that offer panoramic views of the surrounding landscape. History lovers often include this fort in their travel itinerary when visiting Ellora and Grishneshwar. Traveling by cab allows tourists to comfortably reach and explore the fort."
  },
  {
    title: "Bhadra Maruti Temple",
    description:
      "Bhadra Maruti Temple is a well-known temple dedicated to Lord Hanuman located near the Ellora Caves and Grishneshwar Temple. The temple is unique because it houses a rare reclining idol of Lord Hanuman in a sleeping position. Devotees believe that visiting this temple brings peace, protection, and blessings. The temple attracts pilgrims who are visiting nearby Jyotirlinga and historical attractions. A cab trip from Mumbai makes it convenient to include this sacred temple in a spiritual journey."
  },
  {
    title: "Aurangabad Caves",
    description:
      "Aurangabad Caves are a group of ancient rock-cut Buddhist caves located on a hillside near the city of Aurangabad. These caves date back to around the 6th and 7th centuries and feature detailed carvings, sculptures, and meditation halls used by Buddhist monks. Visitors interested in history and ancient architecture enjoy exploring these caves and learning about their cultural significance. A comfortable cab ride from Mumbai allows travelers to include Aurangabad Caves in their Grishneshwar pilgrimage trip."
  },
  {
    title: "Panchakki (Water Mill)",
    description:
      "Panchakki, also known as the water mill, is an interesting historical structure located in Aurangabad. Built during the Mughal period, the system uses underground water channels to generate power for grinding grain. The site also includes beautiful gardens, fountains, and a peaceful environment that attracts tourists and history enthusiasts. Visitors often explore this unique engineering structure while visiting Aurangabad’s historical sites. Traveling by cab ensures convenient access to this attraction."
  },
  {
    title: "Bibi Ka Maqbara",
    description:
      "Bibi Ka Maqbara is a famous historical monument in Aurangabad often referred to as the 'Mini Taj Mahal'. Built by Mughal Emperor Aurangzeb’s son in memory of his mother, the monument features elegant Mughal architecture with beautiful domes, gardens, and pathways. Visitors enjoy exploring the monument, learning about its history, and capturing photographs of its impressive design. A cab journey from Mumbai allows travelers to comfortably visit this iconic structure along with nearby attractions."
  },
  {
    title: "Jayakwadi Dam",
    description:
      "Jayakwadi Dam is one of the largest irrigation projects in Maharashtra and is located near Aurangabad. The dam creates a large reservoir known as Nath Sagar Lake and is a peaceful spot for sightseeing, bird watching, and enjoying scenic water views. During certain seasons, migratory birds can be spotted around the reservoir, making it a great destination for nature lovers. Visitors traveling by cab from Mumbai can easily include this relaxing destination during their trip."
  },
  {
    title: "Siddharth Garden and Zoo",
    description:
      "Siddharth Garden and Zoo is a popular recreational attraction in Aurangabad where visitors can enjoy gardens, animal enclosures, and family-friendly activities. The zoo houses various animals and birds, while the garden provides green spaces for relaxation and picnics. Families and tourists often visit the park to spend leisure time after exploring historical monuments in the region. Traveling by cab allows visitors to conveniently explore this destination during their Aurangabad and Grishneshwar tour."
  }
],



services: [
{
name: "Mumbai to Grishneshwar Cab",
description: "Mumbai to Grishneshwar cab service provides comfortable long-distance transportation for devotees traveling to the sacred Grishneshwar Jyotirlinga temple near Ellora in Maharashtra. The temple is one of the twelve Jyotirlingas of Lord Shiva and attracts pilgrims from across India throughout the year. Our vehicles are well-maintained and designed for highway travel with spacious seating and ample luggage capacity for families and groups. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles make the long journey relaxed and convenient. Ideal for pilgrimage tours, religious travel, and family temple visits. Flexible booking options allow devotees to plan their spiritual journey easily."
},
{
name: "Mumbai to Grishneshwar Taxi",
description: "Mumbai to Grishneshwar taxi service offers reliable transportation for devotees visiting the holy Grishneshwar temple located near Aurangabad. The journey passes through well-connected highways and scenic landscapes of Maharashtra, making it comfortable for road travel. Vehicles provide smooth ride quality and comfortable seating for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for temple visits, family pilgrimages, and religious tourism. Air-conditioned vehicles ensure comfortable travel experiences for passengers."
},
{
name: "Grishneshwar Jyotirlinga Cab Mumbai",
description: "Grishneshwar Jyotirlinga cab from Mumbai offers convenient travel for devotees planning darshan at one of the most sacred Shiva temples in India. Located near the famous Ellora Caves, the temple attracts spiritual travelers and tourists alike. Our cab service ensures comfortable transportation with spacious vehicles suitable for highway travel. Professional drivers provide punctual pickup services across Mumbai and ensure safe driving throughout the journey. Pickup is available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours and family temple visits."
},
{
name: "Mumbai to Grishneshwar Cab Service",
description: "Mumbai to Grishneshwar cab service offers dependable transportation for pilgrims and travelers visiting the holy Jyotirlinga temple. Vehicles are well maintained and suitable for long-distance highway travel with comfortable seating and luggage space. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for religious travel, temple darshan trips, and family pilgrimages. Air-conditioned vehicles ensure relaxed journeys throughout the trip."
},
{
name: "Mumbai to Grishneshwar Taxi Service",
description: "Mumbai to Grishneshwar taxi service provides convenient travel options for devotees planning temple visits to the sacred Jyotirlinga shrine. Vehicles provide smooth ride quality and comfortable seating suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for spiritual tours, pilgrimage travel, and family journeys. Air-conditioned vehicles ensure comfortable travel experiences throughout the route."
},
{
name: "Cab from Mumbai to Grishneshwar",
description: "Cab from Mumbai to Grishneshwar offers reliable long-distance transportation for pilgrims traveling to the sacred temple located near Ellora. Vehicles are designed for highway journeys and provide spacious seating and luggage space for passengers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for temple visits, pilgrimage tours, and family travel."
},
{
name: "Taxi from Mumbai to Grishneshwar",
description: "Taxi from Mumbai to Grishneshwar provides dependable transportation for travelers visiting the Jyotirlinga temple and nearby religious destinations. Vehicles offer smooth highway performance and comfortable seating for extended journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for pilgrimage tours and family temple visits."
},
{
name: "Mumbai to Grishneshwar Cab Booking",
description: "Mumbai to Grishneshwar cab booking allows devotees to easily reserve vehicles for temple visits and religious journeys. Online and phone booking options provide quick confirmations and convenient ride scheduling. Vehicles provide comfortable seating and smooth highway travel suitable for long-distance journeys. Professional drivers ensure punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals."
},
{
name: "Mumbai to Grishneshwar Taxi Booking Online",
description: "Mumbai to Grishneshwar taxi booking online provides convenient digital reservations for devotees planning temple darshan trips. Passengers can schedule pickups and receive instant confirmation for their journey. Vehicles provide comfortable seating and smooth ride performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Mumbai to Grishneshwar Cab Price",
description: "Mumbai to Grishneshwar cab price options provide transparent fare estimates for devotees planning temple travel. Pricing depends on vehicle category, travel distance, and trip duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Mumbai to Grishneshwar Taxi Fare",
description: "Mumbai to Grishneshwar taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Passengers can choose economical sedans or spacious SUVs depending on comfort requirements. Professional drivers ensure safe driving and punctual pickup services across Mumbai."
},
{
name: "Mumbai to Grishneshwar One Way Cab",
description: "Mumbai to Grishneshwar one way cab service provides economical transportation for devotees traveling directly to the temple without return travel charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Mumbai to Grishneshwar Round Trip Taxi",
description: "Mumbai to Grishneshwar round trip taxi service offers convenient transportation for devotees planning return travel after temple darshan. Vehicles are suitable for long-distance highway journeys and multi-day trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Jyotirlinga Tour Cab Mumbai",
description: "Jyotirlinga tour cab from Mumbai provides comfortable transportation for devotees planning visits to sacred Jyotirlinga temples such as Grishneshwar, Trimbakeshwar, and Bhimashankar. Vehicles provide spacious seating and smooth highway travel suitable for long pilgrimage journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai."
},
{
name: "Religious Temple Cab Mumbai",
description: "Religious temple cab service from Mumbai offers dedicated transportation for pilgrims visiting famous temples across Maharashtra and nearby states. Vehicles provide comfortable seating and reliable highway performance suitable for spiritual journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
}
],

tableData: [
["Mumbai to Grishneshwar Cab","Mumbai to Grishneshwar Taxi"],
["Grishneshwar Jyotirlinga Cab Mumbai","Mumbai to Grishneshwar Cab Service"],
["Mumbai to Grishneshwar Taxi Service","Cab from Mumbai to Grishneshwar"],
["Taxi from Mumbai to Grishneshwar","Mumbai to Grishneshwar Cab Booking"],
["Mumbai to Grishneshwar Taxi Booking Online","Mumbai to Grishneshwar Cab Price"],
["Mumbai to Grishneshwar Taxi Fare","Mumbai to Grishneshwar One Way Cab"],
["Mumbai to Grishneshwar Round Trip Taxi","Jyotirlinga Tour Cab Mumbai"],
["Religious Temple Cab Mumbai","Temple Tour Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance pilgrimage travel from Mumbai to Grishneshwar Jyotirlinga near Aurangabad. They are familiar with the temple routes, highway travel, and local conditions ensuring a smooth and comfortable spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Grishneshwar cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Grishneshwar cab service operates 24 hours a day. Whether you want to start early morning for temple darshan or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day pilgrimage packages from Mumbai to Grishneshwar temple."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Grishneshwar pilgrimage begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Jyotirlinga Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Mumbai to Grishneshwar Jyotirlinga. Our punctual drivers, comfortable vehicles, and professional service ensure a peaceful spiritual journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Grishneshwar?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Grishneshwar Jyotirlinga for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Grishneshwar Temple?", answer: "The distance from Mumbai to Grishneshwar is approximately 330 km and the journey usually takes around 7 to 8 hours depending on traffic and road conditions." },
  { question: "Can I combine Ellora Caves with the Grishneshwar trip?", answer: "Yes, many travelers combine Grishneshwar Jyotirlinga temple darshan with Ellora Caves sightseeing during the trip." },
  { question: "Which vehicles are available for the trip?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Grishneshwar cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons when many devotees visit the temple." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Grishneshwar." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Kulkarni",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Grishneshwar pilgrimage. The driver was professional and the journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Patil",
    feedback:
      "Excellent cab service for temple travel. Clean vehicle, punctual driver, and a peaceful trip to Grishneshwar Jyotirlinga.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Grishneshwar Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Grishneshwar Jyotirlinga for one-way trips, round trips, and religious temple tours. Travel comfortably and safely with well-maintained vehicles like Innova and Ertiga. Flexible booking options and transparent pricing for hassle-free journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "890"
  }
};










  return (
    <div>
      <Helmet>
  <title>Mumbai to Grishneshwar Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Grishneshwar Jyotirlinga for one-way trips, round trips, and religious temple tours. Travel safely and comfortably with Innova, Ertiga, and other vehicles. Flexible bookings and transparent pricing for hassle-free journeys." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitigrishneshwar;